import { render, staticRenderFns } from "./collectStep1.vue?vue&type=template&id=b78512d8&scoped=true"
import script from "./collectStep1.vue?vue&type=script&lang=ts"
export * from "./collectStep1.vue?vue&type=script&lang=ts"
import style0 from "./collectStep1.vue?vue&type=style&index=0&id=b78512d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78512d8",
  null
  
)

export default component.exports